export default __webpack_public_path__ + "static/media/w4.f955adc8.jpg";